
import Vue from 'vue'
import { PaymentDto } from '@ViewModels/PaymentDto'
import { Loading, Alert, Currency, CreditCardPaymentForm, AgreeGate } from '@/components'
import { SaveButton } from '@/components/buttons'
import { Textbox, Currencybox } from '@/components/formGroups'

export default Vue.extend({
   name: 'PaymentSection',
   props: {
      data: { required: true, type: Object as () => PaymentDto },
      displayData: { required: true, type: Object },
      processing: { required: true },
   },
   data() {
      return {
         submitted: false,
         agreeTermsAndConditions: false,
         recaptchaSiteKey: '6LdspFccAAAAAIMGvLwE7XRhG-treV_vV5xrDqIU',
      }
   },
   computed: {
      validationMessages(): string[] {
         const messages: string[] = []
         if (!this.data.NameOnCard) {
            messages.push('Name on Card is missing')
         }
         if (!this.data.CardNumber) {
            messages.push('Card Number is missing')
         }
         if (this.data.CardExpiryMonth <= 0) {
            messages.push('Expiry Month is missing')
         }
         if (this.data.CardExpiryYear <= 0) {
            messages.push('Expiry Year is missing')
         }
         if (!this.data.CardCvc) {
            messages.push('Card Verification Code is missing')
         }
         if (this.agreeTermsAndConditions === false) {
            messages.push('You must agree to the terms and conditions')
         }
         if (this.data.RecaptchaToken.length === 0) {
            messages.push('You must complete the reCAPTCHA')
         }
         return messages
      },
      warningMessages(): string[] {
         const messages: string[] = []
         if (this.data.PaymentAmount < 1) {
            messages.push('That payment amount seems very low.  Are you sure it is correct?')
         }
         if (this.data.PaymentAmount > 1500) {
            messages.push('That payment amount seems very high. Are you sure it is correct?')
         }
         return messages
      },
      isValid(): boolean {
         return this.validationMessages.length === 0
      },
      allowSubmission(): boolean {
         return !this.submitted || this.isValid
      },
      showValidationError(): boolean {
         return !this.isValid && this.submitted
      },
   },
   mounted() {
      this.startRecaptcha()
   },
   methods: {
      startRecaptcha() {
         const recaptcha = (window as any).grecaptcha
         if (!recaptcha || !recaptcha.render) {
            setTimeout(this.startRecaptcha, 250)
         } else {
            recaptcha.render('recaptcha', {
               sitekey: this.recaptchaSiteKey,
               callback: this.recaptchaCompleted,
               'expired-callback': this.recaptchaExpired,
               'error-callback': this.recaptchaError,
            })
         }
      },
      recaptchaCompleted(token: string) {
         this.$emit('recaptcha', token)
      },
      recaptchaExpired() {
         this.$emit('recaptcha', '')
         ;(window as any).grecaptcha.reset()
      },
      recaptchaError() {
         this.$emit('recaptcha', '')
         ;(window as any).grecaptcha.reset()
      },
      submit() {
         this.submitted = true
         if (this.isValid) {
            this.$emit('click')
         }
      },
   },
   components: {
      Loading,
      Alert,
      Textbox,
      SaveButton,
      Currency,
      Currencybox,
      CreditCardPaymentForm,
      AgreeGate,
   },
})
